module.exports = __webpack_public_path__ + "img/register-banner.95822ba4.jpg";